import { useId } from 'react';

type Props = {
  color: string;
};

export const Ellipse = ({ color }: Props) => {
  const id = useId();
  return (
    <svg viewBox="0 0 343 391" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" filter={`url(#filter-${id})`}>
        <ellipse
          cx="172.437"
          cy="195.295"
          rx="146.437"
          ry="76.8731"
          fill={`url(#paint-${id})`}
        />
      </g>
      <defs>
        <filter
          id={`filter-${id}`}
          x="-92.4224"
          y="-0.000526428"
          width="529.719"
          height="390.591"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="59.2112"
            result="effect1_foregroundBlur_5741_41839"
          />
        </filter>
        <linearGradient
          id={`paint-${id}`}
          x1="269.094"
          y1="123.145"
          x2="72.1258"
          y2="284.225"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0865385" stopColor="#D8CB8F" />
          <stop offset="0.355769" stopColor={color} />
          <stop offset="0.668269" stopColor="#D8CB8F" />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
};
